import { TColorNew } from '@src/models/colors';

const COLOR_CLASS_PREFIX = 'Color__';
const BG_CLASS_PREFIX = 'Bg__';
const BORDER_COLOR_CLASS_PREFIX = 'BorderColor__';

const COLOR_PROPERTIES = {
  color: COLOR_CLASS_PREFIX,
  background: BG_CLASS_PREFIX,
  borderColor: BORDER_COLOR_CLASS_PREFIX,
};

export const getColorClass = ({
  view,
  property,
}: {
  view: TColorNew | string;
  property: keyof typeof COLOR_PROPERTIES;
}) => {
  if (!view) return '';
  return `${COLOR_PROPERTIES[property]}${view}`;
};
